import { ELCLogger, TriggerType } from '@estee/elc-logging';
import { ISurveyData, SurveyApiSdk } from '~api/SurveyApiSdk';

export class SurveyRepository {
    private logger: ELCLogger;
    private surveyApiSdk: SurveyApiSdk;

    constructor(serviceName: string, serviceVersion: string, surveyApiSdk: SurveyApiSdk) {
        this.logger = new ELCLogger({ serviceName, serviceVersion });
        this.surveyApiSdk = surveyApiSdk;
    }

    public saveSurveyData = async (surveyData: ISurveyData) => {
        try {
            await this.surveyApiSdk.saveSurveyData(surveyData);
        } catch (error) {
            this.logger.error({
                triggerType: TriggerType.runtimeError,
                message: `${error}`
            });
        }
    };
}
